<template>
  <div class="monitor-container container-view" ref="pageView">
    <!-- title -->
    <section class="title-section">
      <p class="titleInfo fl">{{ curTime }}</p>
      <p class="titleText">广州市城市冷链配送监控看板</p>
    </section>
    <section class="main">
      <section class="chartPanel">
        <!--topLeft-->
        <div
          class="chartPanel-child topLeft"
          v-loading="topLeftLoading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <div class="chartPanel_title">
            <span>·</span>城市冷链配送企业排行Top5
          </div>
          <div
            class="chartPanel-child-chartArea"
            ref="topLeftChartDOM"
            style="font-size: 1rem"
          ></div>
        </div>
        <!--topRight-->
        <div
          class="chartPanel-child topRight"
          v-loading="topRightLoading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <div class="chartPanel_title">
            <span>·</span>城市冷链配送车辆运营走势（近7天）
          </div>
          <div
            class="chartPanel-child-chartArea"
            ref="topRightChartDOM"
            style="font-size: 1rem"
          ></div>
        </div>
        <!--centerMap-->
        <div
          class="chartPanel-child middleCenter"
          v-loading="mapLoading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <div class="chartPanel-child-chartArea" ref="page_center-map"></div>
        </div>
        <!--center-->
        <div
          class="chartPanel-child centerLeft"
          v-loading="centerLeftLoading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <div class="chartPanel_title">
            <span>·</span>广州市限行区域早晚高峰冷藏车运行情况
          </div>
          <div class="radio-box">
            <el-radio-group v-model="areaRadio" @input="switchRadio">
              <el-radio :label="100">A区</el-radio>
              <el-radio :label="101">B区</el-radio>
              <el-radio :label="145">C区</el-radio>
            </el-radio-group>
          </div>
          <div
            class="chartPanel-child-chartArea"
            ref="centerLeftChartDOM"
            style="font-size: 1rem"
          ></div>
        </div>
        <div
          class="chartPanel-child centerRight"
          v-loading="centerRightLoading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <div class="chartPanel_title">
            <span>·</span>城市冷链配送车辆使用率
          </div>
          <div class="centerRight-content">
            <div
              class="chartPanel-child-box"
              ref="centerRightChartDOM1"
              style="font-size: 1rem"
            ></div>
            <div
              class="chartPanel-child-box"
              ref="centerRightChartDOM2"
              style="font-size: 1rem"
            ></div>
          </div>
        </div>
        <!--bottomLeft-->
        <div
          class="chartPanel-child bottomLeft"
          v-loading="bottomLeftLoading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <div class="chartPanel-child-box">
            <div class="chartPanel_title">
              <span>·</span> 进入广州重点限行区域情况
            </div>
            <img
              class="train-umber"
              src="@/assets/images/alarmBoard/trainNumber.png"
              alt=""
            />
            <img
              class="total-distance"
              src="@/assets/images/alarmBoard/totalDistance.png"
              alt=""
            />
            <div
              class="bottom_child w100"
              ref="bottomLeftChartLeft"
              style="font-size: 1rem"
            ></div>
          </div>
        </div>
        <!--bottomCenter-->
        <div
          class="chartPanel-child bottomCenter"
          v-loading="centerRightLoading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <div class="chartPanel-child-box">
            <div class="chartPanel_title"><span>·</span>限行区域行驶数据</div>
            <span class="small-title">昨日行驶次数</span>

            <div
              class="bottom_child w50"
              ref="bottomCenterChartLeft"
              style="font-size: 1rem"
            ></div>
            <div
              class="bottom_child w25"
              ref="bottomCenterChartCenter"
              style="font-size: 1rem"
            ></div>
            <div
              class="bottom_child w25"
              ref="bottomCenterChartRight"
              style="font-size: 1rem"
            ></div>
          </div>
        </div>
        <!--bottomRight-->
        <div
          class="chartPanel-child bottomRight"
          v-loading="bottomRightCenterLoading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <div class="chartPanel-child-box">
            <div class="chartPanel_title">
              <span>·</span>城市冷链配送车辆24小时运营走势
            </div>
            <div
              class="bottom_child w100"
              ref="bottomRightChartLeft"
              style="font-size: 1rem"
            ></div>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
// plugin
import moment from "moment";
import Echarts from "echarts";
import { mapGetters, mapMutations } from "vuex";
import {
  getComparyVehicleOrderNew,
  getStorageTonnageOrderNew,
  getKeyRestrictAreaInfo,
  getOperatingTrendForYesterday,
  getBottomLeftData,
  fetchCenterLeftData
} from "@/api/board/alarm";
import {
  converData,
  handleMapData,
  converVehicleData,
  handleCityData
} from "../home/chartConfig.js";
import {
  fetchMapData,
  FetchNumberByAreaName,
  FetchCompanyNumAndRateByAreaName,
  FetchCompanyInfoByCity
} from "@/api/home/gdHome.js";

// mixins
import resizeListener from "_private/mixins/resizeListener";

// charts setting
import echartsHome from "./echartsHome.js";

export default {
  mixins: [resizeListener],
  data() {
    return {
      curTime: moment().format("YYYY-MM-DD HH:mm:ss"),
      timeInterval: null, // 时间显示定时器
      resizeTimer: null, // resize事件节流timer
      clientWidth: document.documentElement.clientWidth, // 页面宽度
      clientHeight: document.documentElement.clientHeight, // 页面高度
      reloadDataTime: 1000 * 60 * 60, // 刷新数据时间间隔
      areaRadio: 100,

      /************ topLeft ****************/
      topLeftLoading: false, // 左上角数据正在加载
      topLeftChartData: [],

      /*********** topRight ********************/
      topRightLoading: false, // 右上角数据正在加载
      topRightChartData: [],

      /*********** centerLeft ********************/
      centerLeftLoading: false, // 左下角数据正在加载
      centerLeftData: [],

      /*********** centerRight ********************/
      centerRightLoading: false, // 左下角数据正在加载
      centerRightData: [],

      /*********** bottomLeft ********************/
      bottomLeftLoading: false, // 左下角数据正在加载
      bottomRightCenterLoading: false, // 下右角数据正在加载

      /************* centerMap ********************/
      fetchMapChartDataTimer: null,
      mapChartInstance: null, // 地图图表实例
      mapChartData: {
        freezerList: [],
        storageList: [],
        vehicleList: [],
        vehicleLat: []
      },
      storageData: [],
      mapLoading: false,
      mapChartHighlightTimer: null,
      isGoDown: true // 是否下钻地图
    };
  },
  created() {
    !this.isFullScreen && this.updateFullScreen();
  },

  mounted() {
    this.$nextTick(() => {
      // 获取地图业务数据
      this.fetchTopLeftChartData();
      this.fetchTopRightData();
      this.setCLockTimeInterval();
      this.getCenterLeftData();
      this.getCenterRightData();

      this.fetchBottomLeftData();
      this.fetchAvgBottomRightData();
      this.initMap();
      window.onresize = () => {
        this.resetEcharts();
      };
      // echartsHome.resizeEcharts();
    });
  },

  beforeDestroy() {
    clearInterval(this.timeInterval); // 清除定时器
    clearInterval(this.mapChartHighlightTimer);
  },

  computed: {
    ...mapGetters(["isFullScreen", "userId"])
  },

  methods: {
    ...mapMutations(["updateFullScreen"]),

    // 设置左上角钟表定时器
    setCLockTimeInterval() {
      clearInterval(this.timeInterval);
      // 设置定时器，每个1秒获取一次时间信息
      this.timeInterval = setInterval(() => {
        this.curTime = moment().format("YYYY-MM-DD HH:mm:ss");
      }, 1000);
    },
    // 重置echarts
    resetEcharts() {
      this.echartsMapObj && this.echartsMapObj.resize();
    },
    // 监控浏览器及元素变化
    resizeListener() {
      clearTimeout(this.resizeTimer);

      this.resizeTimer = setTimeout(() => {
        this.$nextTick(() => {
          this.clientWidth = document.documentElement.clientWidth;
          this.clientHeight = document.documentElement.clientHeight;
          this.mapChartInstance && this.mapChartInstance.resize();
        });
      }, 300);
    },
    // 渐变色
    setLinearColor(startColor, endColor) {
      return new Echarts.graphic.LinearGradient(
        0,
        0,
        0,
        1,
        [
          {
            offset: 0,
            color: startColor
          },
          {
            offset: 1,
            color: endColor
          }
        ],
        false
      );
    },
    // 渐变色
    setHLinearColor(startColor, endColor) {
      return new Echarts.graphic.LinearGradient(
        0,
        0,
        1,
        0,
        [
          {
            offset: 0,
            color: startColor
          },
          {
            offset: 1,
            color: endColor
          }
        ],
        false
      );
    },
    /*****************************中间部分地图数据*************************/
    // 初始化地圖
    async initMap() {
      // 获取地区内部/外部轮廓地理位置信息
      let geoDirName = this.$GLOBAL_CONFIG.home.map.geoDirName; // geo文件件
      let geoPromises = [
        import(`@/assets/geo/${geoDirName}/inline.json`),
        import(`@/assets/geo/${geoDirName}/outline.json`),
        import(`@/assets/geo/${geoDirName}/guangzhou/outline.json`)
      ];
      let [inlineGeo, outlineGeo, guangdongOutlineGeo] = await Promise.all(
        geoPromises
      );

      // 初始化地图
      this.mapOutlineGeo = Object.freeze(outlineGeo);
      this.mapGuangdongOutlineGeo = Object.freeze(guangdongOutlineGeo);
      Echarts.registerMap("inlineMap", inlineGeo);
      Echarts.registerMap("outlineMap", outlineGeo);
      this.getMapData();
    },
    // 请求数据
    async getMapData() {
      try {
        this.mapLoading = true;
        let [mapData, vehicleData, companyData] = await Promise.all([
          fetchMapData(),
          FetchNumberByAreaName(),
          FetchCompanyNumAndRateByAreaName()
        ]);
        if (mapData.code && vehicleData.code && companyData.code) {
          this.mapChartData = {
            companyList: converData(companyData.result || []),
            freezerList: handleMapData(mapData.result.freezerLonLatList || []),
            storageList: handleMapData(mapData.result.storageLonLatList || []),
            vehicleLat: this.filterVehicle(
              handleMapData(mapData.result.vehicleLonLatList || [])
            ),
            vehicleList: converVehicleData(vehicleData.result || [])
          };
        } else {
          this.errorMessage("获取地图数据数据失败");
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.mapLoading = false;
        this.initMapEcharts("", this.mapChartData);
      }
    },
    // 初始化地图echarts
    initMapEcharts(cityName = "", data = {}) {
      const mapChartData = data;
      const option = {
        legend: {
          data: ["车辆", "冷库", "企业"],
          orient: "horizontal",
          textStyle: {
            color: "#666"
          },
          top: "2%",
          left: 20
        },
        tooltip: {
          show: true
        },
        visualMap: {
          show: true,
          type: "piecewise",
          right: 10,
          bottom: 20,
          calculable: true,
          animation: true,
          seriesIndex: [3],
          hoverLink: false,
          // 数据颜色范围，值越大颜色越深
          pieces: [
            {
              min: 100,
              color: this.setLinearColor("#006FEC", "#3B45F4")
            },
            {
              min: 76,
              max: 100,
              color: this.setLinearColor("#2B84EF", "#5B63F6")
            },
            {
              min: 51,
              max: 75,
              color: this.setLinearColor("#549CF2", "#7A81F7")
            },
            {
              min: 26,
              max: 50,
              color: this.setLinearColor("#7CB3F6", "#999EF9")
            },
            {
              min: 0,
              max: 25,
              color: this.setLinearColor("#A4CAF9", "#B8BCFB")
            }
          ]
        },
        geo: {
          name: cityName + "inlineMap",
          type: "map",
          map: cityName + "inlineMap",
          roam: true,
          zoom: 1,
          top: "5%",
          bottom: "5%",
          left: "5%",
          right: "13%",
          tooltip: {
            show: false
          },
          label: {
            normal: {
              show: true,
              position: "inside", //显示位置
              offset: [0, 0], //偏移设置
              color: "#fff",
              textShadowColor: "rgba(0,0,0,0.3)",
              textShadowBlur: 2,
              textShadowOffsetX: 0,
              textShadowOffsetY: 4,
              fontWeight: "lighter",
              fontSize: 12
            },
            emphasis: {
              color: "#fff"
            }
          },
          itemStyle: {
            normal: {
              borderColor: "#fff",
              borderWidth: 1
            },
            emphasis: {
              areaColor: "#3648F3"
            }
          },
          regions: [
            {
              name: "东沙群岛",
              itemStyle: {
                areaColor: "#A8C8FA"
              },
              label: {
                color: "#333"
              }
            }
          ]
        },
        series: [
          {
            name: "企业",
            type: "scatter",
            coordinateSystem: "geo",
            itemStyle: {
              color: "#01af3c" //波纹圈颜色
            },
            emphasis: {
              itemStyle: {
                opacity: 1
              }
            },
            data: mapChartData.companyList
          },
          {
            name: "冷库",
            type: "scatter",
            coordinateSystem: "geo",
            hoverAnimation: true,
            itemStyle: {
              color: "#ff9600"
            },
            emphasis: {
              itemStyle: {
                opacity: 1
              }
            },
            data: mapChartData.storageList
          },
          {
            name: "车辆",
            type: "scatter",
            coordinateSystem: "geo",
            hoverAnimation: true,
            itemStyle: {
              color: "#00b7f4"
            },
            emphasis: {
              itemStyle: {
                opacity: 1
              }
            },
            tooltip: {
              show: true,
              extraCssText: "width:300px; white-space:pre-wrap" // 额外添加到浮层的css样式，用于换行。
            },
            data: mapChartData.vehicleLat
          },
          {
            type: "map",
            map: cityName + "inlineMap",
            geoIndex: 0,
            roam: true,
            tooltip: {
              show: true,
              formatter: params => {
                let str = "";
                str = `
                <div style="padding:5px 10px">
                  <p style="font-size:18px;margin:0px">${params.name}</p>
                  <p>
                    <span style="display:block;margin:5px 0">入住企业总数：${params.data.comparyNum}</span>
                    <span style="display:block;margin:5px 0">车辆总数：${params.value}</span>
                    <span style="display:block;margin:5px 0">冷库总数：${params.data.storageNum}</span>
                    <span style="display:block;margin:5px 0">冷柜总数：${params.data.freezerNum}</span>
                  </p>
                <div>
                `;
                return str;
              }
            },
            data: mapChartData.vehicleList,
            label: {
              emphasis: {
                show: false
              },
              normal: {
                show: false
              }
            }
          }
        ]
      };
      if (this.echartsMapObj) {
        this.echartsMapObj.clear();
      }

      this.echartsMapObj = Echarts.init(this.$refs["page_center-map"]);
      this.echartsMapObj.setOption(option);
      window.addEventListener("resize", () => {
        this.echartsMapObj.resize();
        this.echartsMapObj.clear();
        this.echartsMapObj.setOption(option);
      });
      this.echartsMapObj.on("click", this.dropdown);
      this.echartsMapObj.on("georoam", params => {
        if (params.dy || params.dx) return; //如果是拖拽事件则退出
        let _option = this.echartsMapObj.getOption(); //获取最新的option配制
        this.echartsMapObj.clear(); //清空
        this.echartsMapObj.setOption(_option); //更新修改后的option配制
      });
      this.isGoDown && this.echartsMapObj.on("dblclick", this.dropUp);
    },
    // 下钻城市
    async dropdown(params) {
      if (params.componentSubType !== "map") return;
      if (
        !this.isGoDown ||
        params.name === "广东省" ||
        params.name === "东沙群岛"
      )
        return;
      let code = this.conversion(params.name);
      let json = await import(`@/assets/geo/guangdong/couties/${code}.json`);

      // 初始化地图
      Echarts.registerMap(params.name + "inlineMap", json);
      this.fetchCenterCompanyData(params.name, params.data.bin);
      this.isGoDown = false;
    },
    // 获取地图下钻二级市，区，县数据
    async fetchCenterCompanyData(cityName = "", bin) {
      try {
        this.mapLoading = true;
        let that = this;
        let [res, vehicleData] = await Promise.all([
          FetchCompanyInfoByCity({ cityName }),
          FetchNumberByAreaName(this.$qs.stringify({ bin: bin }))
        ]);
        if (res && vehicleData) {
          if (res.code === 1 && res.result) {
            that.mapChartData = {
              companyList: handleCityData(res.result.companyLonLatList || []),
              freezerList: handleMapData(res.result.freezerLonLatList || []),
              storageList: handleMapData(res.result.storageLonLatList || []),
              vehicleLat: this.filterVehicle(
                handleMapData(res.result.vehicleLonLatList || [])
              ),
              vehicleList: converVehicleData(vehicleData.result || [], "count")
            };
            this.initMapEcharts(cityName, that.mapChartData);
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.mapLoading = false;
      }
    },
    // 筛选当前的车辆列表，将不属于当前地图的点过滤掉
    filterVehicle(vehicleList) {
      // // 地图轮廓多边形的点的数据
      // const polygonPoints = this.mapGuangdongOutlineGeo.features[0].geometry
      //   .coordinates[0][0];
      // let result = null;

      // // 过滤掉不属于该地区的点

      // result = vehicleList.filter(item => {
      //   if (this.isInPolygon(item.value, polygonPoints)) {
      //     return item;
      //   }
      // });
      // return result;
      // 地图轮廓多边形的点的数据;
      let arr = [];
      this.mapOutlineGeo.features.forEach(f => {
        let polygonPoints = "";
        if (this.mapOutlineGeo.cp) {
          polygonPoints = f.geometry.coordinates[0];
        } else {
          polygonPoints = f.geometry.coordinates[0][0];
        }

        let result = null;
        // 过滤掉不属于该地区的点
        result = vehicleList.filter(item => {
          if (this.isInPolygon(item.value, polygonPoints)) {
            return item;
          }
        });
        arr.push(...result);
      });
      return arr;
    },
    /**
     * 判断当前点是否再地图 geoJSON 的多边形范围之内
     * @param {array} checkPoint 要判断的经纬度
     * @param {array} polygonPoints geoJSON 中的多边形数据
     * @return {boolean} 返回是否再当前多边形范围之内
     */
    isInPolygon(checkPoint, polygonPoints) {
      let counter = 0;
      let i;
      let xinters;
      let p1, p2;
      let pointCount = polygonPoints.length;
      p1 = polygonPoints[0];

      for (i = 1; i <= pointCount; i++) {
        p2 = polygonPoints[i % pointCount];
        if (
          checkPoint[0] > Math.min(p1[0], p2[0]) &&
          checkPoint[0] <= Math.max(p1[0], p2[0])
        ) {
          if (checkPoint[1] <= Math.max(p1[1], p2[1])) {
            if (p1[0] != p2[0]) {
              xinters =
                ((checkPoint[0] - p1[0]) * (p2[1] - p1[1])) / (p2[0] - p1[0]) +
                p1[1];
              if (p1[1] == p2[1] || checkPoint[1] <= xinters) {
                counter++;
              }
            }
          }
        }
        p1 = p2;
      }
      if (counter % 2 == 0) {
        return false;
      } else {
        return true;
      }
    },

    // 返回上一层
    dropUp() {
      this.getMapData();
      this.isGoDown = true;
    },
    // 计算横向尺寸百分比
    calcXDirectionSizeByPercent(size) {
      // return size;
      // 目前此页面不需要自适应，则注释下计算字体
      return (size / 1920) * this.clientWidth;
    },

    // 计算纵向向尺寸百分比
    calcYDirectionSizeByPercent(size) {
      // return size;
      // 目前此页面不需要自适应，则注释下计算字体
      return (size / 1080) * this.clientHeight;
    },
    // 千分符处理
    handleData(data) {
      let regex = /\d{1,3}(?=((\d{3})+$))/g;
      if ((data + "").indexOf(".") > -1) {
        regex = /\d{1,3}(?=((\d{3})+\.))/g;
      }
      let str = (data + "").replace(regex, "$&,");
      // let str = data.toLocaleString();
      return str;
    },
    conversion(name) {
      let code = 0;
      switch (name) {
        case "湛江市":
          code = 440800;
          break;
        case "茂名市":
          code = 440900;
          break;
        case "阳江市":
          code = 441700;
          break;
        case "江门市":
          code = 440700;
          break;
        case "云浮市":
          code = 445300;
          break;
        case "珠海市":
          code = 440400;
          break;
        case "中山市":
          code = 442000;
          break;
        case "佛山市":
          code = 440600;
          break;
        case "肇庆市":
          code = 441200;
          break;
        case "深圳市":
          code = 440300;
          break;
        case "东莞市":
          code = 441900;
          break;
        case "广州市":
          code = 440100;
          break;
        case "清远市":
          code = 441800;
          break;
        case "惠州市":
          code = 441300;
          break;
        case "韶关市":
          code = 440200;
          break;
        case "汕尾市":
          code = 441500;
          break;
        case "河源市":
          code = 441600;
          break;
        case "揭阳市":
          code = 445200;
          break;
        case "梅州市":
          code = 441400;
          break;
        case "汕头市":
          code = 440500;
          break;
        case "潮州市":
          code = 445100;
          break;
        default:
          code = 440100;
      }
      return code;
    },
    /************************** topLeft ************************************/
    // 城市冷链配送企业排行Top5
    async fetchTopLeftChartData() {
      try {
        this.topLeftLoading = true;
        const res = await getComparyVehicleOrderNew();
        if (res.code === 1) {
          this.initTopLeftChart(res.result);
        }
      } finally {
        this.topLeftLoading = false;
      }
    },
    // 初始化左上角图表
    initTopLeftChart(data) {
      const dataX = [],
        dataValue = [];
      data.forEach(item => {
        dataX.push(item.name);
        dataValue.push(item.countNum);
      });
      echartsHome.drawTopChart(this.$refs.topLeftChartDOM, {
        dataX,
        dataValue
      });
    },

    /************************** topRight ************************************/
    // 城市冷链配送车辆每周运营走势
    async fetchTopRightData() {
      try {
        this.topRightLoading = true;
        const res = await fetchCenterLeftData({ day: 7, userId: this.userId });
        if (res.code === 1) {
          this.initTopRightChart(res.result);
        }
      } finally {
        this.topRightLoading = false;
      }
    },
    // 初始化右上角图表
    initTopRightChart(data) {
      const dataX = [],
        barData = [],
        lineData = [];
      data.forEach(item => {
        dataX.push(item.key);
        barData.push(item.runningKilometers);
        lineData.push(item.runningTime);
      });
      echartsHome.drawPillarLineChart(this.$refs.topRightChartDOM, {
        dataX,
        barData,
        lineData,
        colorConfig: {
          barColor: ["#12AFED", "#1DC7FA", "#2564F4", "#0D31D2"],
          lineColor: ["#FFB72F", "rgba(237,75,105,.3)", "rgba(174, 112, 79, 0)"]
        }
      });
    },

    /************************** centerMap ************************************/

    /************************** centerLeft ************************************/
    // 广州市限行区域晚高峰冷藏车运行情况（A,B,C）
    async getCenterLeftData() {
      try {
        this.centerLeftLoading = true;
        const res = await getStorageTonnageOrderNew({});
        if (res.code === 1) {
          this.storageData = res.result;
          const dataX = [],
            morningData = [],
            eveningData = [];
          res.result.forEach(item => {
            if (item.areaId === 100) {
              if (item.amOrPm === 1) {
                dataX.push("早高峰7-9时");
                morningData.push(item.allVehicle);
                morningData.push(item.coldVehicle);
              } else {
                dataX.push("晚高峰17-19时");
                eveningData.push(item.allVehicle);
                eveningData.push(item.coldVehicle);
              }
            }
          });
          echartsHome.drawPillarChart(this.$refs.centerLeftChartDOM, {
            dataX,
            morningData,
            eveningData
          });
        }
      } finally {
        this.centerLeftLoading = false;
      }
    },
    switchRadio(index) {
      let areaId = index;
      const dataX = [],
        morningData = [],
        eveningData = [];
      this.storageData.forEach(item => {
        if (item.areaId === areaId) {
          if (item.amOrPm === 1) {
            dataX.push("早高峰7-9时");
            morningData.push(item.allVehicle);
            morningData.push(item.coldVehicle);
          } else {
            dataX.push("晚高峰17-19时");
            eveningData.push(item.allVehicle);
            eveningData.push(item.coldVehicle);
          }
        }
      });
      echartsHome.drawPillarChart(this.$refs.centerLeftChartDOM, {
        dataX,
        morningData,
        eveningData
      });
    },
    // 城市冷链配送车辆使用率及限行区域行驶数据
    async getCenterRightData() {
      try {
        this.centerRightLoading = true;
        const res = await getBottomLeftData({ userId: this.userId });
        if (res.code === 1) {
          this.initCenterRightEcharts(res.result);
          this.initBottomCenterEcharts(res.result);
        }
      } finally {
        this.centerRightLoading = false;
      }
    },
    // 中间右侧的图
    initCenterRightEcharts(data = []) {
      echartsHome.drawDashBoardChart(this.$refs.centerRightChartDOM1, {
        rateValue: data.vehicleRate,
        title: "昨日使用率",
        unit: "%"
      });
      const dataX = [],
        dataValue = [];

      data.coldTransportResults.forEach(item => {
        dataX.push(item.key);
        dataValue.push(item.vehicleRate);
      });
      echartsHome.drawRakingChart(this.$refs.centerRightChartDOM2, {
        dataX,
        dataValue,
        inverse: true,
        title: {
          text: "近7天城市冷链配送车辆使用率",
          top: "18%",
          right: "5%",
          textStyle: {
            fontSize: 12
          }
        }
      });
    },
    // 限行区域情况
    initBottomCenterEcharts(data = []) {
      const dataX = [],
        dataValue = [];
      data.coldTransportResults.forEach(item => {
        dataX.push(item.key);
        dataValue.push(item.passAreaTimes);
      });
      echartsHome.drawRakingChart(this.$refs.bottomCenterChartLeft, {
        dataX,
        dataValue,
        inverse: false,
        showY: true,
        title: {
          text: "近7天限行区域行驶次数",
          top: "18%",
          left: "center",
          textStyle: {
            fontSize: "15"
          }
        }
      });
      echartsHome.drawDashBoardChart(this.$refs.bottomCenterChartCenter, {
        inverse: false,
        rateValue: data.vehicleCount,
        name: "总次数"
      });
      echartsHome.drawDashBoardChart(this.$refs.bottomCenterChartRight, {
        inverse: false,
        rateValue: data.average,
        name: "平均车次"
      });
    },

    /************************** bottomLeft ************************************/
    // 获取城市冷配车在限时限行区域内的运行率
    async fetchBottomLeftData() {
      try {
        this.bottomLeftLoading = true;
        const res = await getKeyRestrictAreaInfo();
        if (res.code === 1) {
          this.initBottomLeftChart(res.result);
        }
      } finally {
        this.bottomLeftLoading = false;
      }
    },
    // 初始化底部左侧柱状图
    initBottomLeftChart(data) {
      const labelData = [],
        leftData = [],
        rightData = [];
      // data.forEach(item => {
      //   labelData.push(item.areaName);
      //   leftData.push(item.vehicleNumb);
      //   rightData.push(item.odomByArea);
      // });
      for (let i = 0; i < data.length; i++) {
        labelData.push(data[i].areaName);
        leftData.push(data[i].vehicleNumb);
        rightData.push(data[i].odomByArea);
      }
      echartsHome.drawContrastChart(this.$refs.bottomLeftChartLeft, {
        labelData,
        leftData,
        rightData
      });
    },

    /************************** bottomRight ************************************/
    // 城市冷链配送车辆24小时运营走势
    async fetchAvgBottomRightData() {
      try {
        this.bottomRightCenterLoading = true;
        const res = await getOperatingTrendForYesterday();
        if (res.code === 1) {
          this.initDrawPillarLineChart(res.result);
        }
      } finally {
        this.bottomRightCenterLoading = false;
      }
    },
    initDrawPillarLineChart(data) {
      const dataX = [],
        barData = [],
        lineData = [];
      data.forEach(item => {
        dataX.push(item.sort);
        barData.push(item.runOdom);
        lineData.push(item.runVehicle);
      });
      echartsHome.drawPillarLineChart(this.$refs.bottomRightChartLeft, {
        dataX,
        barData,
        lineData,
        colorConfig: {
          barColor: ["#EFA132", "#FFD692", "#FFB11B", "#B67700"],
          lineColor: ["#274DF2"]
        }
      });
    },
    // 计算渐变颜色
    calcGradualChangeColor(index, length, startColor, endColor) {
      const rColor =
        startColor[0] + ((endColor[0] - startColor[0]) / length) * index;
      const gColor =
        startColor[1] + ((endColor[1] - startColor[1]) / length) * index;
      const bColor =
        startColor[2] + ((endColor[2] - startColor[2]) / length) * index;

      return `rgb(${rColor}, ${gColor}, ${bColor})`;
    }
  }
};
</script>

<style lang="scss" scoped>
$layout-width: 1920px;
$layout-height: 1080px;

.monitor-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;

  /*标题*/
  .title-section {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    z-index: 2;
    box-sizing: border-box;
    width: 100%;
    height: 0.6rem;
    padding-top: 0.11rem;
    background-image: url("~@/assets/images/alarmBoard/bigScreenTitleBg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;

    p {
      margin: 0;
    }

    .titleInfo {
      color: #3f83ff;
      font-size: 0.14rem;
      word-spacing: 1em;
      margin-left: 0.18rem;
      margin-top: 0.12rem;
    }

    .titleText {
      width: 5.6rem;
      height: 0.3rem;
      margin: 0 auto;
      text-align: center;
      font-size: 0.22rem;
      color: #fff;
      font-weight: bolder;
    }
  }

  .main {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    p {
      margin: 0;
    }

    .chartPanel {
      &_title {
        display: flex;
        align-items: center;
        height: 0.35rem;
        line-height: 0.35rem;
      }
      &-child {
        position: absolute;
        background-repeat: no-repeat;
        background-size: 100% 100%;

        &.topLeft {
          left: (10px / $layout-width) * 100%;
          top: (80px / $layout-height) * 100%;
          width: (482px / $layout-width) * 100%;
          height: (320px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 92%;
          background-position-y: 100%;
        }

        &.topRight {
          right: (10px / $layout-width) * 100%;
          top: (80px / $layout-height) * 100%;
          width: (482px / $layout-width) * 100%;
          height: (320px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 92%;
          background-position-y: 100%;
        }

        &.middleCenter {
          left: 0;
          right: 0;
          top: (80px / $layout-height) * 100%;
          margin: 0 auto;
          width: (936px / $layout-width) * 100%;
          height: (650px / $layout-height) * 100%;
          background-color: #fff;
        }
        &.centerLeft {
          left: (10px / $layout-width) * 100%;
          bottom: (340px / $layout-height) * 100%;
          width: (482px / $layout-width) * 100%;
          height: (320px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 92%;
          background-position-y: 100%;

          .radio-box {
            position: absolute;
            right: 0.4rem;
            top: 0.44rem;
            z-index: 100;
            /deep/ .el-radio__label {
              font-size: 0.12rem;
            }
          }
        }
        &.centerRight {
          right: (10px / $layout-width) * 100%;
          bottom: (340px / $layout-height) * 100%;
          width: (482px / $layout-width) * 100%;
          height: (320px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 92%;
          background-position-y: 100%;

          .centerRight-content {
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 100%;

            .chartPanel-child-box {
              width: 50%;
              height: 100%;
            }
          }
        }
        &.bottomLeft {
          left: (10px / $layout-width) * 100%;
          bottom: (20px / $layout-height) * 100%;
          width: (482px / $layout-width) * 100%;
          height: (303px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 92%;
          background-position-y: 100%;

          .train-umber {
            width: 0.77rem;
            position: absolute;
            top: 20%;
            left: 20%;
          }
          .total-distance {
            width: 1.51rem;
            position: absolute;
            top: 20%;
            left: 60%;
          }
        }
        &.bottomCenter {
          left: 26%;
          bottom: (20px / $layout-height) * 100%;
          width: (920px / $layout-width) * 100%;
          height: (303px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 92%;
          background-position-y: 100%;

          .small-title {
            position: absolute;
            left: 67%;
            top: 18%;
            display: inline-block;
            z-index: 100;
            color: #000;
            font-weight: bolder;
            font-size: 0.18rem;
          }
        }
        &.bottomRight {
          right: (10px / $layout-width) * 100%;
          bottom: (20px / $layout-height) * 100%;
          width: (482px / $layout-width) * 100%;
          height: (303px / $layout-height) * 100%;
          background-image: url("~@/assets/images/alarmBoard/boardBorder.png");
          background-size: 100% 92%;
          background-position-y: 100%;
        }

        .chartPanel-child-box {
          display: flex;
          justify-content: space-between;
          width: 100%;
          height: 100%;
        }

        .chartPanel_title {
          position: absolute;
          height: 0.3rem;
          height: 0.25rem;
          top: 0;
          left: 0.15rem;
          color: #000;
          font-size: 0.18rem;
          font-weight: bolder;

          span {
            display: inline-block;
            color: #3f83ff;
            width: 0.14rem;
          }
        }

        &-slide {
          position: absolute;
          right: 0.25rem;
          display: flex;
          z-index: 10;
          font-size: 0.14rem;

          li {
            margin-left: 0.03rem;
            padding: 0.05rem 0.06rem;
            font-size: 0.12rem;
            color: #7b89dc;
            transition: all 0.3s;
            cursor: pointer;

            &:hover,
            &.active {
              color: red;
              background: #7b89dc;
              border-radius: 0.05rem;
            }
          }
        }
        span.chartPanel-child-slide {
          color: redfff;
        }

        &-chartArea {
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
        }

        .w25 {
          width: 25%;
          height: 100%;
        }

        .w50 {
          width: 45%;
          height: 100%;
        }
        .w100 {
          width: 100%;
          height: 100%;
        }

        .run_time {
          position: relative;
          .item_title {
            position: absolute;
            width: 100%;
            top: 0;
            left: 0;
            font-size: 0.12rem;
            color: #acc7ee;
            top: 0.42rem;
            left: 50%;
            transform: translateX(-50%);
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
